var _path, _path2, _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryGd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_9479)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_9479",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_9479)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#E42235"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 2.66675,
    width: 22.6667,
    height: 14.6667,
    fill: "#079B77"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2858_9479",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 24,
    height: 16
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 2.66675,
    width: 22.6667,
    height: 14.6667,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2858_9479)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39322 10.1319C4.77072 10.736 5.3127 11.1348 5.8175 11.2372C6.09541 11.2935 5.58658 10.019 5.80832 9.88042C5.99751 9.7622 6.90777 10.8221 6.98747 10.601C7.17087 10.0922 7.06268 9.37173 6.65468 8.71879C6.06935 7.78206 6.0465 8.40031 4.46411 7.72925C4.62956 8.68893 3.80789 9.19518 4.39322 10.1319Z",
    fill: "#FFD938"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 10.0001L25.3332 2.66675H2.6665L13.9998 10.0001ZM13.9998 10.0001L2.6665 17.3334H25.3332L13.9998 10.0001Z",
    fill: "#FFD93B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 13.3334C15.8408 13.3334 17.3332 11.841 17.3332 10.0001C17.3332 8.15913 15.8408 6.66675 13.9998 6.66675C12.1589 6.66675 10.6665 8.15913 10.6665 10.0001C10.6665 11.841 12.1589 13.3334 13.9998 13.3334Z",
    fill: "url(#paint0_linear_2858_9479)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9997 11.0286L12.4322 12.1575L13.0216 10.318L11.4635 9.17612L13.3952 9.16817L13.9997 7.3335L14.6042 9.16817L16.5358 9.17612L14.9777 10.318L15.5671 12.1575L13.9997 11.0286Z",
    fill: "#FFD938"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2858_9479",
    x1: 10.6665,
    y1: 6.66675,
    x2: 10.6665,
    y2: 13.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E21C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE1225"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_9479"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryGd);
export default __webpack_public_path__ + "static/media/Country=GD.430790e459c1a9f0a8c1b2e202c5d864.svg";
export { ForwardRef as ReactComponent };